"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("../../services/core");
var _reactstrap = require("reactstrap");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _icon = _interopRequireDefault(require("wever-core/dist/components/common/icon"));
var _utils = require("../../services/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Referent = _ref => {
  let {
    alias,
    index,
    value,
    parent,
    onChange,
    onDelete,
    form
  } = _ref;
  /*
        Contact comptabilité
  Responsable marketing / communication
  Responsable RSE
  Responsable RH
  Représentant QHSSE
  Représentant mobilité
  Représentant Sport
  Représentant CSE (pour les entreprises de plus de 50 salariés)
    */
  const jobOptions = [{
    value: 'Contact comptabilité',
    label: (0, _core._translate)('Contact comptabilité')
  }, {
    value: 'Responsable marketing / communication / commercial',
    label: (0, _core._translate)('Responsable marketing / communication / commercial')
  }, {
    value: 'Responsable RSE',
    label: (0, _core._translate)('Responsable RSE')
  }, {
    value: 'Responsable RH',
    label: (0, _core._translate)('Responsable RH')
  }, {
    value: 'Représentant QHSSE',
    label: (0, _core._translate)('Représentant QHSSE')
  }, {
    value: 'Représentant mobilité',
    label: (0, _core._translate)('Représentant mobilité')
  }, {
    value: 'Représentant Sport',
    label: (0, _core._translate)('Représentant Sport')
  }, {
    value: 'Représentant CSE (pour les entreprises de plus de 50 salariés)',
    label: (0, _core._translate)('Représentant CSE (pour les entreprises de plus de 50 salariés)')
  }, {
    value: 'Dirigeant',
    label: (0, _core._translate)('Dirigeant')
  }, {
    value: 'Recherche et développement',
    label: (0, _core._translate)('Recherche et développement')
  }];
  const getJobSelection = (0, _react.useCallback)(() => {
    return jobOptions.find(job => job.value === value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "referent-container",
    key: alias + index
  }, alias !== 'referents' && parent && /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    options: parent.map(referent => {
      return {
        value: referent,
        label: referent.email
      };
    }),
    placeholder: (0, _core._translate)('registerapp_club_referent_placeholder_choose_referent'),
    onChange: e => {
      if (!e.value) {
        return;
      }
      onChange(index, 'lastname', e.value.lastname);
      onChange(index, 'firstname', e.value.firstname);
      onChange(index, 'email', e.value.email);
      onChange(index, 'phone', e.value.phone);
      onChange(index, 'gender', e.value.gender);
      onChange(index, 'job', e.value.job);
    },
    isClearable: true
  }), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_referent_lastname'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    name: "lastname",
    type: "text",
    value: value.lastname,
    onChange: e => onChange(index, 'lastname', e.target.value)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_referent_firstname'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    name: "firstname",
    type: "text",
    value: value.firstname,
    onChange: e => onChange(index, 'firstname', e.target.value)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('collectorapp_email_pro_label'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    name: "email",
    type: "email",
    value: value.email,
    onChange: e => onChange(index, 'email', e.target.value),
    onBlur: e => (0, _utils.isEmailValid)(e.target.value, _core._translate)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('structurereferencementapp_civility_phone'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    name: "phone",
    type: "tel",
    value: value.phone,
    onChange: e => onChange(index, 'phone', e.target.value),
    onBlur: e => (0, _utils.isPhoneValid)(e.target.value, _core._translate)
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_referent_gender_civil'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "px-3 mx-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "radio",
    name: alias + '_' + index,
    value: "genre_femme",
    onChange: e => onChange(index, 'gender', e.target.value),
    checked: value.gender === 'genre_femme'
  }), (0, _core._translate)('common_form_response_gender_female')), /*#__PURE__*/_react.default.createElement("label", {
    className: "px-3 mx-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "radio",
    name: alias + '_' + index,
    value: "genre_homme",
    onChange: e => onChange(index, 'gender', e.target.value),
    checked: value.gender === 'genre_homme'
  }), (0, _core._translate)('common_form_response_gender_male')), /*#__PURE__*/_react.default.createElement("label", {
    className: "px-3 mx-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "radio",
    name: alias + '_' + index,
    value: "genre_nsp",
    onChange: e => onChange(index, 'gender', e.target.value),
    checked: value.gender === 'genre_nsp'
  }), (0, _core._translate)('common_form_response_gender_nsp')))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "my-4 question"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    md: 6,
    lg: 5
  }, (0, _core._translate)('registerapp_club_referent_job'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    options: jobOptions,
    value: jobOptions.find(job => job.value === value.job),
    onChange: e => onChange(index, 'job', e.value)
  }))), value.delete || value.delete !== false ? /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "w-100 px-2 d-flex justify-content-end"
  }, index > 0 ? /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    color: "danger",
    onClick: () => onDelete(index),
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: "trash"
  })) : null) : null);
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Referent);